import { Component, inject, Inject, OnDestroy, OnInit } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { LoaderComponent } from './modules/shared/loader/components/loader/loader.component';
import { CoreUIFlashToastModule, CoreUIToastsV2Module } from "lib-klab-core-ui";
import { AppEventsService, AuthRedirectEffect, PageTitleService } from 'lib-klab-core';
import { map } from 'rxjs';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, LoaderComponent, CoreUIToastsV2Module, CoreUIFlashToastModule, AsyncPipe],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  private readonly appEvents = inject(AppEventsService);
  private readonly _authRedirectEffect = inject(AuthRedirectEffect);
  private readonly pageTitle = inject(PageTitleService);

  readonly loaderApp$ = this.appEvents.loader().pipe(
    map((v: any) => Boolean(v?.visible)),
  );
}
